module.exports = __webpack_public_path__ + "static/img/sk.80d4eb69.svg";